#import '../../../../shared/graphql/fragments/lead-step-fragment.graphql'

query GetStepsByStage($leadId: ID!) {
    lead(id: $leadId) {
        id
        leadTasksBySource {
            steps {
                stage {
                    id
                }
                steps {
                    ...LeadStepFragment
                }
            }
        }
    }
}
